import { useSuspenseQuery } from '@tanstack/react-query';

import { accessorialQueryOptions } from '../data-provider';

export const useSuspenseAccessorial = (accessorialKey: number) => {
  return useSuspenseQuery(accessorialQueryOptions(accessorialKey));
};
